// removed by extract-text-webpack-plugin
module.exports = {"table":"HistoryTable__table___sbPjX"};